import FileSaver from 'file-saver';
import React, { useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Navigate, useNavigate,Link } from 'react-router-dom';
import { CurrentCompanyContext } from '../../App.js';
import { TIME_ZONE, toQueryString, useFromQueryString } from '../../utils.js';


import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Row from 'react-bootstrap/Row';
import { Container } from '../layout/AppLayout.js';

import { FilterMenu } from '../shared/Filters.js';
import Header, { HeaderActions } from "../shared/Header.js";
import Pagination from '../shared/Pagination.js';
import Spinner from '../shared/Spinner.js';

import useFeatureChecker, { AllowedFeature, DeniedFeature } from '../shared/FeatureChecker.js';
import DigitalsTable from './DigitalsTable.js';
import LogsDigitalSubmenu from './LogsDigitalSubmenu.js'
import Col from 'react-bootstrap/Col';



export default function DigitalsListPage(){
  const CheckFeatures = useFeatureChecker()

  const queryString = useFromQueryString()
  const navigate = useNavigate()

  const [ currentFilters, setCurrentFilters ] = useState({
    page: parseInt(queryString.page) || 1,
    limit: parseInt(queryString.limit) || 50,
    events:queryString.events || 'all',
    platforms:queryString.platforms || 'all'
  })

  const query = useQuery(`logsdigitals?${toQueryString(currentFilters)}`, {
    keepPreviousData: true,
  })
  useEffect(() => {
    navigate('?' + toQueryString(currentFilters), { replace: true })
  }, [currentFilters])
  return (
    <Container>
      <Row>
        <Header title="Logs digitales" items={[
          { label: "Logs digitales" },
        ]}>
          <HeaderActions>
            <CheckFeatures feature="CREATE_LOGS_DIGITALS_IMPLEMENTATION">
              <Link to="/digitals/new" className="btn btn-primary">Crear implementación</Link>
            </CheckFeatures>
          </HeaderActions>
        </Header>

      </Row>

      <LogsDigitalSubmenu/>


      <Row className="mb-2">
        <CheckFeatures feature="LIST_LOGS_DIGITALS">
          <AllowedFeature>
            <Col className="col-12">
              {
                query.isLoading ?
                  <div className="text-center my-4 py-4">
                    <Spinner />
                  </div>
                :
                <DigitalsTable logs={query.data && query.data.result && query.data.result.items || []} />
              }
            
            </Col>
          </AllowedFeature>
          <DeniedFeature>
            <Navigate to={'/error?error=403'}/>
          </DeniedFeature>
        </CheckFeatures>
      </Row>

      <Row className="mt-2">
        <Pagination
          pagination={query.data && query.data.pagination}
          isLoading={query.isFetching}
          onChange={page => setCurrentFilters(prev => ({ ...prev, page }))}
        />
      </Row>
    </Container>
  )
}
